import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './OfferAndDealDatePicker.css';
import React, { useContext, useMemo, createRef, useRef, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Flatpickr from 'react-flatpickr';
import { Arabic } from 'flatpickr/dist/l10n/ar.js';
import { Russian } from 'flatpickr/dist/l10n/ru.js';
import { Czech } from 'flatpickr/dist/l10n/cs.js';
import { Dutch } from 'flatpickr/dist/l10n/nl.js';
import { Finnish } from 'flatpickr/dist/l10n/fi.js';
import { German } from 'flatpickr/dist/l10n/de.js';
import { Japanese } from 'flatpickr/dist/l10n/ja.js';
import { Norwegian } from 'flatpickr/dist/l10n/no.js';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
import { Swedish } from 'flatpickr/dist/l10n/sv.js';
import { Mandarin } from 'flatpickr/dist/l10n/zh.js';
import { Danish } from 'flatpickr/dist/l10n/da.js';
import { French } from 'flatpickr/dist/l10n/fr.js';
import { Italian } from 'flatpickr/dist/l10n/it.js';
import { Korean } from 'flatpickr/dist/l10n/ko.js';
import { Polish } from 'flatpickr/dist/l10n/pl.js';
import { Romanian } from 'flatpickr/dist/l10n/ro.js';
import { Spanish } from 'flatpickr/dist/l10n/es.js';
import { Ukrainian } from 'flatpickr/dist/l10n/uk.js';
import { Turkish } from 'flatpickr/dist/l10n/tr.js';
import { DATE_RANGE_FACET_NAME } from '../ListingOffersAndDeals';
import { addQueryString, deleteQueryString } from '../../Listing/index';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import { ReactComponent as IconArrowLeft } from '../../../resources/icons/IconArrowLeft.svg';
import { ReactComponent as IconArrowRight } from '../../../resources/icons/IconArrowRight.svg';
import { ReactComponent as IconChevronDown } from '../../../resources/icons/IconChevronDown.svg';
import { get, canUseDOM } from '../../../utils';
var commonStyles = "c1hy6aiu";
var ltrStyles = "lgvbbp7";
var rtlStyles = "r8qzx65";
var getFormatedDate = function getFormatedDate(date, lang) {
  return new Date(date).toLocaleDateString(lang === 'en' ? 'en-GB' : lang, {
    // year: 'numeric',
    day: 'numeric',
    month: 'short'
  });
};
var OfferAndDealDatePicker = function OfferAndDealDatePicker(_ref) {
  var filter = _ref.filter,
    closeMobileOpener = _ref.closeMobileOpener,
    setValue = _ref.setValue,
    submitedValue = _ref.submitedValue,
    valueReadableString = _ref.valueReadableString,
    value = _ref.value,
    clearText = _ref.clearText,
    ctaText = _ref.ctaText,
    setListingFilter = _ref.setListingFilter,
    externalVisible = _ref.externalVisible,
    setExternalVisible = _ref.setExternalVisible;
  var sitecoreContext = useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var history = useHistory();
  var currentLang = get(sitecoreContext, 'language').toLowerCase();
  var labelText = get(filter, 'title.jss.value');
  var dateFromFieldName = get(filter, 'fieldNameItem.item.dateFromFieldName.value');
  var dateToFieldName = get(filter, 'fieldNameItem.item.dateToFieldName.value');
  var _React$useState = React.useState(),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    valueForSubmited = _React$useState2[0],
    setValueForSubmited = _React$useState2[1];
  var fieldOpenedRef = useRef(null);
  var filterName = get(filter, 'name') || '';
  var fieldId = filterName ? filterName.toLowerCase().replace(/ /g, '-') : '';
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    fieldVisible = _useState2[0],
    setFieldVisible = _useState2[1];
  var fp = /*#__PURE__*/createRef();
  var currentLocale = useMemo(function () {
    var langHash = {
      ar: Arabic,
      ru: Russian,
      cs: Czech,
      nl: Dutch,
      fi: Finnish,
      de: German,
      ja: Japanese,
      no: Norwegian,
      pt: Portuguese,
      sv: Swedish,
      zh: Mandarin,
      da: Danish,
      fr: French,
      it: Italian,
      ko: Korean,
      pl: Polish,
      ro: Romanian,
      es: Spanish,
      uk: Ukrainian,
      tr: Turkish
    };
    return langHash[currentLang];
  }, [currentLang]);
  React.useEffect(function () {
    if (!value) {
      clearFilter();
    }
  }, [value]);
  var commonSubmit = function commonSubmit() {
    closeMobileOpener();
    setListingFilter();
    setFieldVisible(false);
    submitedValue && submitedValue(valueForSubmited);
  };
  var clearFilter = function clearFilter() {
    if (fp && fp.current && fp.current.flatpickr) {
      fp.current.flatpickr.clear();
    }
    setValue({
      value: '',
      valueReadableString: ''
    });
    setValueForSubmited({
      value: '',
      valueReadableString: ''
    });
    deleteQueryString(DATE_RANGE_FACET_NAME, history);
    commonSubmit();
  };
  var submitFilter = function submitFilter() {
    addQueryString(DATE_RANGE_FACET_NAME, value, history);
    commonSubmit();
  };
  var hideDD = function hideDD(e) {
    if (fieldOpenedRef.current) {
      var mobileDevice = window.matchMedia("(max-width: 991px)").matches;
      if (e.type === 'scroll') {
        if (mobileDevice) return;
      }
      if (e.type === 'click') {
        if (mobileDevice || e.target.closest("#".concat(fieldId))) return;
      }
      setFieldVisible(false);
    }
  };
  useEffect(function () {
    fieldOpenedRef.current = fieldVisible;
  }, [fieldVisible]);
  useEffect(function () {
    if (canUseDOM) {
      window.addEventListener('scroll', hideDD);
      document.addEventListener("click", hideDD);
    }
    return function () {
      if (canUseDOM) {
        window.removeEventListener('scroll', hideDD);
        document.removeEventListener("click", hideDD);
      }
    };
  }, []);
  useEffect(function () {
    if (externalVisible && externalVisible === filterName) {
      setFieldVisible(true);
      setExternalVisible('');
    }
  }, [externalVisible, filterName, setExternalVisible]);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles),
    id: fieldId
  }, /*#__PURE__*/React.createElement("div", {
    className: "button d-none d-lg-flex ".concat(fieldVisible ? 'button--active' : ''),
    onClick: function onClick() {
      setFieldVisible(!fieldVisible);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "button__text"
  }, labelText), /*#__PURE__*/React.createElement(IconChevronDown, null)), /*#__PURE__*/React.createElement("div", {
    className: "dropdown ".concat(fieldVisible ? 'd-flex d-lg-block' : 'd-none')
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-lg-none dropdown-header"
  }, /*#__PURE__*/React.createElement("button", {
    className: "dropdown-header__back",
    onClick: function onClick() {
      setFieldVisible(false);
    }
  }, rtl ? /*#__PURE__*/React.createElement(IconArrowRight, {
    className: "icon"
  }) : /*#__PURE__*/React.createElement(IconArrowLeft, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("h2", {
    className: "dropdown-header__text"
  }, labelText), /*#__PURE__*/React.createElement("button", {
    className: "dropdown-header__clear",
    onClick: clearFilter
  }, clearText)), /*#__PURE__*/React.createElement("div", {
    className: "dropdown-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dropdown-body__clear d-none d-lg-block"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn-link",
    onClick: clearFilter
  }, clearText)), /*#__PURE__*/React.createElement(Flatpickr, {
    ref: fp,
    "aria-label": labelText,
    options: {
      showMonths: 1,
      mode: "range",
      minDate: 'today',
      inline: true,
      locale: currentLocale || 'en',
      nextArrow: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\"><path fill=\"#007CBA\" fill-rule=\"nonzero\" d=\"M8.394 5.5L13 10l-4.606 4.5a1.904 1.904 0 0 1 0-2.724L10.212 10 8.394 8.224a1.904 1.904 0 0 1 0-2.724z\"/></svg>",
      prevArrow: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\"><path fill=\"#007CBA\" fill-rule=\"nonzero\" d=\"M8.394 5.5L13 10l-4.606 4.5a1.904 1.904 0 0 1 0-2.724L10.212 10 8.394 8.224a1.904 1.904 0 0 1 0-2.724z\"/></svg>"
    },
    onChange: function onChange(date) {
      if (date && date.length !== 0) {
        /* setDateInit(date); */
        var date0Temp = new Date(date[0]);
        var userTimezoneOffset = date0Temp.getTimezoneOffset() * 60000;
        var date0 = new Date(date0Temp.getTime() - userTimezoneOffset).toString();
        if (date[1]) {
          var date1Temp = new Date(date[1]);
          var userTimezoneOffset1 = date1Temp.getTimezoneOffset() * 60000;
          var date1 = new Date(date1Temp.getTime() - userTimezoneOffset1).toString();
          var dateValue = "(".concat(dateToFieldName, " > ").concat(Date.parse(date0) / 1000, " AND ").concat(dateFromFieldName, " < ").concat(Date.parse(date1) / 1000, ")");
          var dateString = "".concat(getFormatedDate(date[0], currentLang), " - ").concat(getFormatedDate(date[1], currentLang));
          var _value = {
            value: dateValue,
            valueReadableString: dateString
          };
          setValue(_value);
          setValueForSubmited(_value);
        } else {
          var _value2 = {
            value: "(".concat(dateToFieldName, " > ").concat(Date.parse(date0) / 1000 - 86400, " AND ").concat(dateFromFieldName, " < ").concat(Date.parse(date0) / 1000 + 86400, ")"),
            valueReadableString: getFormatedDate(date[0], currentLang)
          };
          setValue(_value2);
          setValueForSubmited(_value2);
        }
      }
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "dropdown-footer"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary",
    onClick: submitFilter
  }, ctaText))));
};
export default OfferAndDealDatePicker;